import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useRef, useState } from "react";
import classNames from "classnames";
import DownloadIcon from "assets/icons/download.svg?react";
import { Tooltip } from "@mui/material";
import moment from "moment";
import workspaceService from "api/workspaceService";
import { ENotificationType, notification } from "utils/notification";
import { formatPrice } from "utils/appPlans";

const InvoiceCard: FC<Props> = ({ item }) => {
  const rootRef = useRef(null);
  const refWrapper = useRef(null);
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    if (downloading) return;
    setDownloading(true);

    try {
      const res = await workspaceService.downloadInvoice(item.Id);

      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${(item.Number || "faktura").replace(/[\\/]/g, "_")}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => window.URL.revokeObjectURL(url), 30 * 1000);
    } catch {
      notification({
        type: ENotificationType.ERROR,
        title: "Faktura",
        text: "Nie udało się pobrać faktury.",
      });
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className={styles.workerTab} ref={rootRef}>
      <div className={styles.data}>
        <div className={styles.name}>
          <div className={styles.name}>{item.Number}</div>
        </div>
        <div className={styles.edelivery}>
          {moment(item.Date).format("DD.MM.yyyy")}
        </div>
        <div className={styles.nota}>{formatPrice(item.Total ?? 0)}</div>
        <div className={styles.total}>
          <div
            className={classNames(styles.paid, !item.Paid ? styles.unpaid : null)}
          >
            {item.Paid ? "Opłacona" : "Nie opłacona"}
          </div>
        </div>

        <div className={styles.more} ref={refWrapper}>
          <Tooltip title="Pobierz">
            <div>
              <DownloadIcon
                onClick={handleDownload}
                className={classNames(styles.icon, downloading && styles.busy)}
              />
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default InvoiceCard;
